export enum Columns {
  Size = 'size',
  Replenishment = 'replenishment',
  Sold = 'sold',
  SalesRate = 'sale_rate',
  Stock = 'stock',
  OptimalStock = 'optimal_stock',
  WarehouseInventory = 'wh_qty',
  WhNames = 'wh_names',
  NextReplenishment = 'replenishment_time',
  Coverage = 'coverage',
  ExpectedCoverage = 'expected_coverage',
  Constraints = 'constraints',
}
